/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	GetDataStream200,
	GetDataStream400,
	GetDataStream404,
	GetDataStream500,
	ListConditionSpans200,
	ListConditionSpans400,
	ListConditionSpans401,
	ListConditionSpans404,
	ListConditionSpans422,
	ListConditionSpans500,
	ListConditionSpansParams,
	ListConditionSpansQuery200,
	ListConditionSpansQuery400,
	ListConditionSpansQuery401,
	ListConditionSpansQuery404,
	ListConditionSpansQuery422,
	ListConditionSpansQuery500,
	ListConditionSpansQueryBody,
	ListDataStreamPoints200,
	ListDataStreamPoints400,
	ListDataStreamPoints403,
	ListDataStreamPoints404,
	ListDataStreamPoints500,
	ListDataStreamPointsParams,
	ListDataStreams200Item,
	ListDataStreams400,
	ListDataStreams500,
	ListDataStreamsParams,
	ListMultiStreamDataPoints200,
	ListMultiStreamDataPoints400,
	ListMultiStreamDataPoints403,
	ListMultiStreamDataPoints500,
	ListMultiStreamDataPointsParams,
	ListMultiStreamDataPointsQuery200,
	ListMultiStreamDataPointsQuery400,
	ListMultiStreamDataPointsQuery403,
	ListMultiStreamDataPointsQuery500,
	ListMultiStreamDataPointsQueryBody,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListDataStreamsUrl = (params?: ListDataStreamsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		const explodeParameters = ["zoneIds", "unitCategories"];

		if (Array.isArray(value) && explodeParameters.includes(key)) {
			value.forEach((v) => {
				normalizedParams.append(key, v === null ? "null" : String(v));
			});
			return;
		}

		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams?${stringifiedParams}`
		: `/data-streams`;
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const listDataStreams = async (
	params?: ListDataStreamsParams,
	options?: RequestInit,
): Promise<ListDataStreams200Item[]> => {
	return customFetch<ListDataStreams200Item[]>(getListDataStreamsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListDataStreamsQueryKey = (params?: ListDataStreamsParams) => {
	return ["data-streams", ...(params ? [params] : [])] as const;
};

export const getListDataStreamsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListDataStreamsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataStreams>>> = ({
		signal,
	}) => listDataStreams(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreams>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreams>>
>;
export type ListDataStreamsQueryError = ListDataStreams400 | ListDataStreams500;

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params: undefined | ListDataStreamsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useSetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListDataStreamsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreams>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreams>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreams>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listDataStreams>>>(
			{ queryKey: getListDataStreamsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useGetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListDataStreamsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreams>>>(
			getListDataStreamsQueryKey(params),
		);
};

export const getGetDataStreamUrl = (streamId: number) => {
	return `/data-streams/${streamId}`;
};

/**
 * @summary Get a single data stream by ID
 */
export const getDataStream = async (
	streamId: number,
	options?: RequestInit,
): Promise<GetDataStream200> => {
	return customFetch<GetDataStream200>(getGetDataStreamUrl(streamId), {
		...options,
		method: "GET",
	});
};

export const getGetDataStreamQueryKey = (streamId: number) => {
	return ["data-streams", streamId] as const;
};

export const getGetDataStreamQueryOptions = <
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDataStreamQueryKey(streamId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataStream>>> = ({
		signal,
	}) => getDataStream(streamId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getDataStream>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDataStreamQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDataStream>>
>;
export type GetDataStreamQueryError =
	| GetDataStream400
	| GetDataStream404
	| GetDataStream500;

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single data stream by ID
 */

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetDataStreamQueryOptions(streamId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single data stream by ID
 */
export const useSetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		updater:
			| Awaited<ReturnType<typeof getDataStream>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getDataStream>> | undefined,
			  ) => Awaited<ReturnType<typeof getDataStream>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getDataStream>>>(
			{ queryKey: getGetDataStreamQueryKey(streamId) },
			updater,
		);
	};
};

/**
 * @summary Get a single data stream by ID
 */
export const useGetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getDataStream>>>(
			getGetDataStreamQueryKey(streamId),
		);
};

export const getListDataStreamPointsUrl = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams/${streamId}/data-points?${stringifiedParams}`
		: `/data-streams/${streamId}/data-points`;
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const listDataStreamPoints = async (
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: RequestInit,
): Promise<ListDataStreamPoints200> => {
	return customFetch<ListDataStreamPoints200>(
		getListDataStreamPointsUrl(streamId, params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListDataStreamPointsQueryKey = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	return [
		"data-streams",
		streamId,
		"data-points",
		...(params ? [params] : []),
	] as const;
};

export const getListDataStreamPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListDataStreamPointsQueryKey(streamId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listDataStreamPoints>>
	> = ({ signal }) =>
		listDataStreamPoints(streamId, params, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreamPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreamPoints>>
>;
export type ListDataStreamPointsQueryError =
	| ListDataStreamPoints400
	| ListDataStreamPoints403
	| ListDataStreamPoints404
	| ListDataStreamPoints500;

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params: undefined | ListDataStreamPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamPointsQueryOptions(
		streamId,
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useSetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		params: ListDataStreamPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreamPoints>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreamPoints>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreamPoints>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listDataStreamPoints>>
		>({ queryKey: getListDataStreamPointsQueryKey(streamId, params) }, updater);
	};
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useGetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number, params?: ListDataStreamPointsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreamPoints>>>(
			getListDataStreamPointsQueryKey(streamId, params),
		);
};

export const getListMultiStreamDataPointsUrl = (
	params: ListMultiStreamDataPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		const explodeParameters = ["streamIds"];

		if (Array.isArray(value) && explodeParameters.includes(key)) {
			value.forEach((v) => {
				normalizedParams.append(key, v === null ? "null" : String(v));
			});
			return;
		}

		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-points?${stringifiedParams}`
		: `/data-points`;
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const listMultiStreamDataPoints = async (
	params: ListMultiStreamDataPointsParams,
	options?: RequestInit,
): Promise<ListMultiStreamDataPoints200> => {
	return customFetch<ListMultiStreamDataPoints200>(
		getListMultiStreamDataPointsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListMultiStreamDataPointsQueryKey = (
	params?: ListMultiStreamDataPointsParams,
) => {
	return ["data-points", ...(params ? [params] : [])] as const;
};

export const getListMultiStreamDataPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListMultiStreamDataPointsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>
	> = ({ signal }) =>
		listMultiStreamDataPoints(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPoints>>
>;
export type ListMultiStreamDataPointsQueryError =
	| ListMultiStreamDataPoints400
	| ListMultiStreamDataPoints403
	| ListMultiStreamDataPoints500;

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useSetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListMultiStreamDataPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
						| undefined,
			  ) => Awaited<ReturnType<typeof listMultiStreamDataPoints>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>({ queryKey: getListMultiStreamDataPointsQueryKey(params) }, updater);
	};
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useGetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (params: ListMultiStreamDataPointsParams) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>(getListMultiStreamDataPointsQueryKey(params));
};

export const getListMultiStreamDataPointsQueryUrl = () => {
	return `/data-points/query`;
};

/**
 * POST variant of listMultiStreamDataPoints: use it for inputs too complex for URL-encoded query parameters (nested objects, long arrays, precision-sensitive numbers); identical response.
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const listMultiStreamDataPointsQuery = async (
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: RequestInit,
): Promise<ListMultiStreamDataPointsQuery200> => {
	return customFetch<ListMultiStreamDataPointsQuery200>(
		getListMultiStreamDataPointsQueryUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(listMultiStreamDataPointsQueryBody),
		},
	);
};

export const getListMultiStreamDataPointsQueryQueryKey = (
	listMultiStreamDataPointsQueryBody?: ListMultiStreamDataPointsQueryBody,
) => {
	return [
		"POST",
		"data-points",
		"query",
		listMultiStreamDataPointsQueryBody,
	] as const;
};

export const getListMultiStreamDataPointsQueryQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListMultiStreamDataPointsQueryQueryKey(
			listMultiStreamDataPointsQueryBody,
		);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
	> = ({ signal }) =>
		listMultiStreamDataPointsQuery(listMultiStreamDataPointsQueryBody, {
			signal,
			...requestOptions,
		});

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsQueryQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
>;
export type ListMultiStreamDataPointsQueryQueryError =
	| ListMultiStreamDataPointsQuery400
	| ListMultiStreamDataPointsQuery403
	| ListMultiStreamDataPointsQuery500;

export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */

export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsQueryQueryOptions(
		listMultiStreamDataPointsQueryBody,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const useSetListMultiStreamDataPointsQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsQueryBody:
			| ListMultiStreamDataPointsQueryBody
			| undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
						| undefined,
			  ) =>
					| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
					| undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
		>(
			{
				queryKey: getListMultiStreamDataPointsQueryQueryKey(
					listMultiStreamDataPointsQueryBody,
				),
			},
			updater,
		);
	};
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const useGetListMultiStreamDataPointsQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
		>(
			getListMultiStreamDataPointsQueryQueryKey(
				listMultiStreamDataPointsQueryBody,
			),
		);
};

export const getListConditionSpansUrl = (params: ListConditionSpansParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		const explodeParameters = [
			"streamIds",
			"condition[in]",
			"condition[notIn]",
			"condition[not][in]",
			"condition[not][notIn]",
			"aggregates",
		];

		if (Array.isArray(value) && explodeParameters.includes(key)) {
			value.forEach((v) => {
				normalizedParams.append(key, v === null ? "null" : String(v));
			});
			return;
		}

		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/condition-spans?${stringifiedParams}`
		: `/condition-spans`;
};

/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only.
 */
export const listConditionSpans = async (
	params: ListConditionSpansParams,
	options?: RequestInit,
): Promise<ListConditionSpans200> => {
	return customFetch<ListConditionSpans200>(getListConditionSpansUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListConditionSpansQueryKey = (
	params?: ListConditionSpansParams,
) => {
	return ["condition-spans", ...(params ? [params] : [])] as const;
};

export const getListConditionSpansQueryOptions = <
	TData = Awaited<ReturnType<typeof listConditionSpans>>,
	TError =
		| ListConditionSpans400
		| ListConditionSpans401
		| ListConditionSpans404
		| ListConditionSpans422
		| ListConditionSpans500,
>(
	params: ListConditionSpansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpans>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListConditionSpansQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listConditionSpans>>
	> = ({ signal }) => listConditionSpans(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listConditionSpans>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConditionSpansQueryResult = NonNullable<
	Awaited<ReturnType<typeof listConditionSpans>>
>;
export type ListConditionSpansQueryError =
	| ListConditionSpans400
	| ListConditionSpans401
	| ListConditionSpans404
	| ListConditionSpans422
	| ListConditionSpans500;

export function useListConditionSpans<
	TData = Awaited<ReturnType<typeof listConditionSpans>>,
	TError =
		| ListConditionSpans400
		| ListConditionSpans401
		| ListConditionSpans404
		| ListConditionSpans422
		| ListConditionSpans500,
>(
	params: ListConditionSpansParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpans>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listConditionSpans>>,
					TError,
					Awaited<ReturnType<typeof listConditionSpans>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConditionSpans<
	TData = Awaited<ReturnType<typeof listConditionSpans>>,
	TError =
		| ListConditionSpans400
		| ListConditionSpans401
		| ListConditionSpans404
		| ListConditionSpans422
		| ListConditionSpans500,
>(
	params: ListConditionSpansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpans>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listConditionSpans>>,
					TError,
					Awaited<ReturnType<typeof listConditionSpans>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConditionSpans<
	TData = Awaited<ReturnType<typeof listConditionSpans>>,
	TError =
		| ListConditionSpans400
		| ListConditionSpans401
		| ListConditionSpans404
		| ListConditionSpans422
		| ListConditionSpans500,
>(
	params: ListConditionSpansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpans>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only.
 */

export function useListConditionSpans<
	TData = Awaited<ReturnType<typeof listConditionSpans>>,
	TError =
		| ListConditionSpans400
		| ListConditionSpans401
		| ListConditionSpans404
		| ListConditionSpans422
		| ListConditionSpans500,
>(
	params: ListConditionSpansParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpans>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListConditionSpansQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only.
 */
export const useSetListConditionSpansQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListConditionSpansParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listConditionSpans>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listConditionSpans>> | undefined,
			  ) => Awaited<ReturnType<typeof listConditionSpans>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listConditionSpans>>>(
			{ queryKey: getListConditionSpansQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only.
 */
export const useGetListConditionSpansQueryData = () => {
	const queryClient = useQueryClient();
	return (params: ListConditionSpansParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listConditionSpans>>>(
			getListConditionSpansQueryKey(params),
		);
};

export const getListConditionSpansQueryUrl = () => {
	return `/condition-spans/query`;
};

/**
 * POST variant of listConditionSpans: use it for inputs too complex for URL-encoded query parameters (nested objects, long arrays, precision-sensitive numbers); identical response.
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only. (POST variant)
 */
export const listConditionSpansQuery = async (
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options?: RequestInit,
): Promise<ListConditionSpansQuery200> => {
	return customFetch<ListConditionSpansQuery200>(
		getListConditionSpansQueryUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(listConditionSpansQueryBody),
		},
	);
};

export const getListConditionSpansQueryQueryKey = (
	listConditionSpansQueryBody?: ListConditionSpansQueryBody,
) => {
	return [
		"POST",
		"condition-spans",
		"query",
		listConditionSpansQueryBody,
	] as const;
};

export const getListConditionSpansQueryQueryOptions = <
	TData = Awaited<ReturnType<typeof listConditionSpansQuery>>,
	TError =
		| ListConditionSpansQuery400
		| ListConditionSpansQuery401
		| ListConditionSpansQuery404
		| ListConditionSpansQuery422
		| ListConditionSpansQuery500,
>(
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpansQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListConditionSpansQueryQueryKey(listConditionSpansQueryBody);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listConditionSpansQuery>>
	> = ({ signal }) =>
		listConditionSpansQuery(listConditionSpansQueryBody, {
			signal,
			...requestOptions,
		});

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listConditionSpansQuery>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConditionSpansQueryQueryResult = NonNullable<
	Awaited<ReturnType<typeof listConditionSpansQuery>>
>;
export type ListConditionSpansQueryQueryError =
	| ListConditionSpansQuery400
	| ListConditionSpansQuery401
	| ListConditionSpansQuery404
	| ListConditionSpansQuery422
	| ListConditionSpansQuery500;

export function useListConditionSpansQuery<
	TData = Awaited<ReturnType<typeof listConditionSpansQuery>>,
	TError =
		| ListConditionSpansQuery400
		| ListConditionSpansQuery401
		| ListConditionSpansQuery404
		| ListConditionSpansQuery422
		| ListConditionSpansQuery500,
>(
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpansQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listConditionSpansQuery>>,
					TError,
					Awaited<ReturnType<typeof listConditionSpansQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConditionSpansQuery<
	TData = Awaited<ReturnType<typeof listConditionSpansQuery>>,
	TError =
		| ListConditionSpansQuery400
		| ListConditionSpansQuery401
		| ListConditionSpansQuery404
		| ListConditionSpansQuery422
		| ListConditionSpansQuery500,
>(
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpansQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listConditionSpansQuery>>,
					TError,
					Awaited<ReturnType<typeof listConditionSpansQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConditionSpansQuery<
	TData = Awaited<ReturnType<typeof listConditionSpansQuery>>,
	TError =
		| ListConditionSpansQuery400
		| ListConditionSpansQuery401
		| ListConditionSpansQuery404
		| ListConditionSpansQuery422
		| ListConditionSpansQuery500,
>(
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpansQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only. (POST variant)
 */

export function useListConditionSpansQuery<
	TData = Awaited<ReturnType<typeof listConditionSpansQuery>>,
	TError =
		| ListConditionSpansQuery400
		| ListConditionSpansQuery401
		| ListConditionSpansQuery404
		| ListConditionSpansQuery422
		| ListConditionSpansQuery500,
>(
	listConditionSpansQueryBody: ListConditionSpansQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listConditionSpansQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListConditionSpansQueryQueryOptions(
		listConditionSpansQueryBody,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only. (POST variant)
 */
export const useSetListConditionSpansQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listConditionSpansQueryBody: ListConditionSpansQueryBody | undefined,
		updater:
			| Awaited<ReturnType<typeof listConditionSpansQuery>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listConditionSpansQuery>> | undefined,
			  ) => Awaited<ReturnType<typeof listConditionSpansQuery>> | undefined),
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listConditionSpansQuery>>
		>(
			{
				queryKey: getListConditionSpansQueryQueryKey(
					listConditionSpansQueryBody,
				),
			},
			updater,
		);
	};
};

/**
 * @summary Find the contiguous stretches where a stream's value matched a condition. Returns stream and fragment references only. (POST variant)
 */
export const useGetListConditionSpansQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (listConditionSpansQueryBody: ListConditionSpansQueryBody) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listConditionSpansQuery>>
		>(getListConditionSpansQueryQueryKey(listConditionSpansQueryBody));
};
